/*
 * @Date: 2022-08-23 18:44:30
 * @LastEditTime: 2022-09-28 11:00:45
 * @FilePath: /activity_cfhd_a20220819syhact/config.ts
 * @Description:
 */

// ！！！！！！！！！！！！！！！！！！！！！！！！！
// 注意更换package.json中的name为自己的项目名
// ！！！！！！！！！！！！！！！！！！！！！！！！！

export const plat = (window as any).isPage =='H5'? 'mobile':'pc'
export const isPage = (window as any).isPage

export const iActivityId = 547461
export const giftId = 542074
export const initFlow = 940783
// 礼包记录和按钮，记得11对应
export const giftRecordId: Array<number> = [940764]
export const giftRecordBtnClass: Array<string> = ['.btn_gift_record']

export const realGiftRecordId: Array<number> = []
export const realGgiftRecordBtnClass: Array<string> = []
export const preRolePopId = 'pop1' 
export const wxBindPopId = 'pop3'
export const backUrl = window.location.href; 

export const btnParam = {
  loginedDiv: 'logined', // 登陆显示区DIV的ID
  unloginDiv: 'unlogin', // 注销显示区DIV的ID
  userinfoSpan: 'milo_userinfo', // 显示用户登陆信息等的ID
  userheadimg: 'milo_headimg', // 显示用户的头像的img标签
  logout: 'logoutBtn', // 注销按钮
  qq: 'qqLoginBtn', // pt QQ登录
  qc: 'qcLoginBtn', // 互联登录
  wx: 'wxLoginBtn', // 微信登录
  wg: 'wgLoginBtn', // wegame登录
  qqwx: 'qqwxLoginBtn', // qqwx联合登录
  qcwx: 'qcwxLoginBtn', // qcwx联合登录
}


